import { NgModule } from '@angular/core';
import {
    DefaultUrlSerializer,
    RouterModule,
    Routes,
    UrlSerializer,
    UrlTree,
} from '@angular/router';
import { PreloadFeatureStrategy } from '@app/router';
import { UiPathComponent } from '@app/uipath.component';
import {
    FeatureFlagGuard,
    FolderParamGuard,
    LicenseGuard,
    ModalGuard,
    NoSessionGuard,
    PermissionGuard,
    TenantGuard,
} from '@guards';

import {
    TENANT_PAGE_MODULES,
    TENANT_ROUTES,
} from './uipath-tenant-routing.module';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        const queryStartIndex = url.indexOf('?');
        const queryStart = queryStartIndex === -1 ? url.length : queryStartIndex;
        const location = url.substring(0, queryStart).toLowerCase();
        const params = url.substring(queryStart, url.length);
        return super.parse(`${location}${params}`);
    }
}

const PARENT_ROUTES: Routes = [{
    path: 'account',
    runGuardsAndResolvers: 'always',
    loadChildren: './pages/auth/auth.module#AuthModule',
    canActivate: [NoSessionGuard],
}, {
    path: 'host',
    runGuardsAndResolvers: 'always',
    canActivate: [PermissionGuard, TenantGuard],
    component: UiPathComponent,
    loadChildren: './pages/host/host.module#HostModule',
}, {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [FolderParamGuard, FeatureFlagGuard, PermissionGuard, TenantGuard, LicenseGuard],
    canDeactivate: [ModalGuard],
    component: UiPathComponent,
    children: TENANT_ROUTES,
}];

@NgModule({
    imports: [
        RouterModule.forRoot(PARENT_ROUTES, {
            preloadingStrategy: PreloadFeatureStrategy,
        }),
        ...TENANT_PAGE_MODULES,
    ],
    providers: [{
        provide: UrlSerializer,
        useClass: LowerCaseUrlSerializer,
    }],
})
export class UiPathRoutingModule { }
